import React from "react";
import { LoaderContainer, LoaderStyle } from "./styles/Loader.styled";

export default function Loader() {
  return (
    <LoaderContainer>
      <LoaderStyle></LoaderStyle>
    </LoaderContainer>
  );
}
